module.exports = __webpack_public_path__ + "static/p02_botonCuentamelo-fde6b2ad6c814db5f729507a21a1ef11.png";